<template>
    <v-dialog v-model="dialog" width="700px">
        <v-card fluid>
            <v-container>
                <p class="title ma-2">Add an additional cost to {{hspt.huis_code }} pricetable {{hspt.hspt_nr}}</p>
                <v-form ref="addHpbk" v-model="addHpbkValid">

                    <v-row no-gutters>
                        <v-col class="ma-2 mt-4 mb-4">
                            <v-autocomplete v-model="kstp_nr" :items="hspt.kstp_nrKeuzes" item-text="kstptaal_oms" item-value="kstp_nr" label="costs" dense @change="updateData"></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-row v-if="kstp_nr > 0&&!allowed" no-gutters>
                        <v-col class="ma-2">
                            <b v-if="!hideAllowed">To Add this item, please contact Anouk</b>
                        </v-col>
                    </v-row>

                    <v-row v-if="kstp_nr > 0&&allowed" no-gutters>
                        <v-col class="ma-2">
                            <v-select v-model="hspt.ktpz_nr" required :items="kstp.ktpz_nrKeuzes" item-value="ktpz_nr" item-text="ktpztaal_oms" label="Sentence" dense></v-select>
                        </v-col>
                    </v-row>

                    <v-row v-if="kstp_nr > 0&&allowed" no-gutters>
                        <v-col class="ma-2">
                            <v-select v-model="hspt.hspt_betaling" required :items="kstp.hspt_betalingKeuzes" item-value="id" item-text="desc" label="Payment" dense :rules="hspt_betalingRules"></v-select>
                        </v-col>
                    </v-row>

                    <v-row v-if="kstp_nr > 0 && kstp.sales_sign_matje == 'yes' && allowed" no-gutters>
                        <v-col class="ma-2">
                            <v-text-field v-model="hspt.hpbk_gtl_verk" :prefix='sales_sign_matje_prefix' :suffix='sales_sign_matje_suffix' :rules="hpbk_gtl_verkRules"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row v-if="kstp_nr > 0 && kstp.purchase_sign_matje == 'yes' && allowed" no-gutters>
                        <v-col class="ma-2">
                            <v-text-field v-model="hspt.hpbk_gtl_ink" :prefix='purchase_sign_matje_prefix' :suffix='purchase_sign_matje_suffix' :rules="hpbk_gtl_verkRules"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row v-if="kstp_nr > 0 && kstp.sales_sign_and == 'yes' && allowed" no-gutters>
                        <v-col class="ma-2">
                            <v-text-field v-model="hspt.hpbk_gtl_verk" :prefix='kstp.sales_sign_and_prefix' :suffix='kstp.sales_sign_and_suffix' :rules="hpbk_gtl_verkRulesPerc"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row v-if="kstp_nr > 0 && kstp.purchase_sign_and == 'yes' && allowed" no-gutters>
                        <v-col class="ma-2">
                            <v-text-field v-model="hspt.hpbk_gtl_ink" :prefix='kstp.purchase_sign_and_prefix' :suffix='kstp.purchase_sign_and_suffix' :rules="hpbk_gtl_verkRulesPerc"></v-text-field>
                        </v-col>
                    </v-row>

                    <!-- <v-row v-if="kstp_nr > 0 && kstp.kstp_mndb != 'No' && allowed" no-gutters>
                        <v-col cols="4" class="px-2">
                            <v-menu v-model="hspt.hpbk_van_datMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" readonly offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="hspt.hpbk_van_dat" label="Arrival from" v-on="on" clearable></v-text-field>
                                </template>
                                <v-date-picker v-model="hspt.hpbk_van_dat" :first-day-of-week="1" @input="hspt.hpbk_van_datMenu = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="4" class="px-2">
                            <v-menu v-model="hspt.hpbk_tm_datMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" readonly offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="hspt.hpbk_tm_dat" label="Arrival until" v-on="on" clearable></v-text-field>
                                </template>
                                <v-date-picker v-model="hspt.hpbk_tm_dat" :first-day-of-week="1" @input="hspt.hpbk_tm_datMenu = false"></v-date-picker>
                            </v-menu>
                        </v-col> -->
                        <!-- <v-col v-if="hspt.hpbk_van_dat > '' && hspt.hpbk_tm_dat > ''" cols="4" class="px-2">
                            <v-checkbox v-model="hspt.hpbk_verlenging" label="Every year"></v-checkbox>
                        </v-col> -->
                    <!-- </v-row> -->
                    <v-row v-if="kstp_nr > 0 && kstp.kstp_mndb != 'No' && allowed" no-gutters>
                        <v-col class="ma-2">
                            <date_picker4
                                :datum="hpbk_van_dat"
                                :startDate="hpbk_van_dat"
                                :isIso="true"
                                label="Arrival from"
                                field="hpbk_van_dat"
                                icon="mdi-calendar-month-outline"
                                :manual="true"
                                @updateData="updateDates"
                                />
                        </v-col>
                        <v-col class="ma-2">
                            <date_picker4
                                label="Arrival to"
                                :datum="hpbk_tm_dat"
                                :startDate="hpbk_tm_dat"
                                :isIso="true"
                                field="hpbk_tm_dat"
                                icon="mdi-calendar-month-outline"
                                :manual="true"
                                @updateData="updateDates"
                                />
                        </v-col>
                    </v-row>
                </v-form>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="primary mx-2" small @click="addHpbk" :disabled="!allowed||!addHpbkValid||!addHpbkValidDates||kstp_nr===0">Save</v-btn>
                    <v-btn color="primary"      small @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
    // import selectHpbk from '@/components/ui/selectors/select_hpbk.vue'
    // import date_picker2 from '@/components/ui/date_picker2.vue';
    import date_picker4 from '@/components/ui/date_picker4.vue';

    export default {
        components: {
            // selectHpbk,
            // date_picker2,
            date_picker4,
        },
        data() {
            return {
                dialog: false,

                allowed: true,
                hideAllowed: true,

                hpbk_van_dat: '',
                hpbk_tm_dat: '',

                addHpbkValid: false,
                hspt_encrid: null,
                hspt: {
                    kstp_nrKeuzes : [],
                },
                kstp: {
                    kstp_mndb: '',
                    ktpz_nrKeuzes : [],
                    hspt_betalingKeuzes : [],
                },
                kstp_nr: 0,
                sales_sign_matje_prefix: '',
                sales_sign_matje_suffix: '',
                purchase_sign_matje_prefix: '',
                purchase_sign_matje_suffix: '',

                kstp_nrRules: [
                    v => !!v || "A Cost is required"
                ],
                hspt_betalingRules: [
                    v => !!v || "A way of Payment is required"
                ],
                hpbk_gtl_verkRules: [
                    v => !!v || "An amount is required"
                ],
                hpbk_gtl_verkRulesPerc: [
                    v => !!v || "A percentage is required"
                ],
            }
        },
        computed: {
            addHpbkValidDates() {
                console.log('validating dates', this.hpbk_van_dat, this.hpbk_tm_dat)
                if (this.kstp_nr > 0 && this.kstp.kstp_mndb === 'Yes') {
                    console.log('validating dates', this.hspt.hpbk_van_dat, this.hspt.hpbk_tm_dat)
                    return (this.hspt.hpbk_van_dat && this.hspt.hpbk_tm_dat);
                }
                return true;
            }
        },
        methods: {
            initData(hspt_encrid) {
                this.hspt_encrid = hspt_encrid;
                this.hspt = {
                    kstp_nrKeuzes : [],
                }
                this.kstp = {
                    ktpz_nrKeuzes : [],
                    hspt_betalingKeuzes : [],
                }
                this.kstp_nr = 0
                this.sales_sign_matje_prefix = ''
                this.sales_sign_matje_suffix = ''
                this.purchase_sign_matje_prefix = ''
                this.purchase_sign_matje_suffix = ''
            },
            openDialog(hspt_encrid, hpbk_encrid) {
                this.initData(hspt_encrid);
                this.getHsptToAddHpbk(hpbk_encrid);
            },
            getHsptToAddHpbk(hpbk_encrid) {
                this.$axios.post("ares/json/ares/huis/hspt/hpbk/getHsptToAddHpbk.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHsptToAddHpbk"
                    },
                    getHsptToAddHpbk: {
                        hspt_encrid: this.hspt_encrid,
                        hpbk_encrid: hpbk_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hspt = res.data.getHsptToAddHpbk;


                        if (this.hspt.kstp_nrKeuzes.length === 1) {
                           this.kstp_nr = this.hspt.kstp_nrKeuzes[0].kstp_nr;
                           this.runStep2();
                        }
                        this.dialog = true;
                    }
                });
            },
            updateData(data) {
                console.log('updateDate', data.field, data.value)
                this.hideAllowed = true;

                this[data.field]=data.value;
                this.allowed = false;
                for (let iIndex=0;iIndex<this.hspt.kstp_nrKeuzes.length;iIndex++){
                    if (this.hspt.kstp_nrKeuzes[iIndex].kstp_nr===data) {
                        this.allowed = this.hspt.kstp_nrKeuzes[iIndex].allowed;
                    }
                }
                if (this.allowed) {
                    this.runStep2();
                    return;
                }
                this.hideAllowed = false;
            },
            updateDates(data) {
                this[data.field] = data.value;
                console.log('updateDates', data.field, data.value)
                this.hspt.hpbk_van_dat = this.hpbk_van_dat;
                this.hspt.hpbk_tm_dat = this.hpbk_tm_dat;
            },

            runStep2() {
                this.$axios.post("ares/json/ares/huis/hspt/hpbk/getKstpToAddHpbk.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getKstpToAddHpbk"
                    },
                    getKstpToAddHpbk: {
                        hspt_encrid: this.hspt.hspt_encrid,
                        kstp_nr: this.kstp_nr
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hideAllowed;
                        this.kstp = res.data.getKstpToAddHpbk;
                        this.hspt.ktpz_nr = this.kstp.ktpz_nrKeuzes[0].id;
                        this.hspt.hspt_betaling = this.kstp.hspt_betalingKeuzes[0].id;

                        this.sales_sign_matje_prefix = this.kstp.sales_sign_matje_prefix;
                        this.sales_sign_matje_suffix = this.kstp.sales_sign_matje_suffix;
                        this.purchase_sign_matje_prefix = this.kstp.purchase_sign_matje_prefix;
                        this.purchase_sign_matje_suffix = this.kstp.purchase_sign_matje_suffix;
                    }
                });
            },
            addHpbk() {
                this.$axios.post("ares/json/ares/huis/hspt/hpbk/addHpbk.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addHpbk"
                    },
                    addHpbk: {
                        hspt_encrid: this.hspt.hspt_encrid,
                        kstp_nr: this.kstp_nr,
                        hpbk_van_dat: this.hspt.hpbk_van_dat,
                        hpbk_tm_dat: this.hspt.hpbk_tm_dat,
                        hpbk_verlenging: this.hspt.hpbk_verlenging,
                        hpbk_gtl_verk: parseFloat(this.hspt.hpbk_gtl_verk),
                        hpbk_gtl_ink: parseFloat(this.hspt.hpbk_gtl_ink),
                        hpbk_betaling: this.hspt.hspt_betaling,
                        ktpz_nr: parseInt(this.hspt.ktpz_nr)
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.addHpbk.text,
                            color: res.data.addHpbk.color
                        });
                        if (res.data.addHpbk.color == "success") {
                            this.$emit('updateData', res.data.addHpbk.regel);
                            this.dialog = false;
                        }
                    }
                })
            }
        }
    }
</script>
